import { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { supabase } from '../../lib/supabase'
import { useWedding } from '../../context/WeddingContext'
import VerifiedBadge from './VerifiedBadge'

const CATEGORY_LABELS = {
  photographer:'Photographer', videographer:'Videographer', decorator:'Decorator',
  mc_dj:'MC / DJ', caterer:'Caterer', aso_ebi:'Aso Ebi', makeup:'Makeup Artist',
  bridal_fashion:'Bridal Fashion', venue:'Venue', live_band:'Live Band',
  cake:'Cake Designer', planner:'Event Planner',
}
const STATUS_LABEL = { inquiry:'Inquiry sent', confirmed:'Booking confirmed', completed:'Completed', cancelled:'Cancelled' }
const fmt = n => `₦${Number(n || 0).toLocaleString()}`

// What to show on the status chip + its colour, given the vendor's response.
function bookingLabel(b) {
  if (b.booking_fee_paid) return { text:'Secured', tone:'#3D8B5E', bg:'rgba(61,139,94,0.1)' }
  switch (b.vendor_response) {
    case 'accepted':  return { text:'Vendor accepted', tone:'#3D8B5E', bg:'rgba(61,139,94,0.1)' }
    case 'countered': return { text:`Countered ${fmt(b.counter_amount)}`, tone:'#B45309', bg:'rgba(217,119,6,0.1)' }
    case 'declined':  return { text:'Declined', tone:'#B91C1C', bg:'rgba(220,38,38,0.1)' }
    default:          return { text:'Awaiting response', tone:'#C4826A', bg:'rgba(196,130,106,0.1)' }
  }
}

// "Your Vendors" — the couple's Aisle bookings, shown on the Planning page.
// Renders nothing if there are no bookings.
export default function YourVendors() {
  const navigate = useNavigate()
  const { wedding } = useWedding()
  const [bookings, setBookings] = useState(null)

  const fetchBookings = () => supabase.rpc('aisle_my_bookings').then(({ data }) => setBookings(data || []), () => setBookings([]))
  useEffect(() => { fetchBookings() }, [])

  // Live: vendor accept/counter/decline reflects without a refresh
  useEffect(() => {
    if (!wedding?.id) return
    const ch = supabase.channel(`couple-bookings-${wedding.id}`)
      .on('postgres_changes', { event:'*', schema:'public', table:'vendor_bookings', filter:`wedding_id=eq.${wedding.id}` }, fetchBookings)
      .subscribe()
    return () => supabase.removeChannel(ch)
  }, [wedding?.id])

  if (!bookings || bookings.length === 0) return null

  return (
    <div style={{ marginBottom:'2rem' }}>
      <h2 style={{ fontFamily:'Gibs, serif', fontWeight:400, fontSize:'1.2rem', margin:'0 0 0.875rem' }}>Your Vendors</h2>
      <div style={{ display:'flex', flexDirection:'column', gap:'0.6rem' }}>
        {bookings.map(b => (
          <button key={b.booking_id} onClick={() => navigate(`/dashboard/aisle/vendor/${b.vendor_id}`)}
            className="card" style={{ display:'flex', alignItems:'center', gap:'0.875rem', padding:'0.75rem', textAlign:'left', cursor:'pointer', border:'1px solid #E5E0D8', width:'100%' }}>
            {b.cover && <img src={b.cover} alt="" style={{ width:48, height:48, borderRadius:'0.625rem', objectFit:'cover', flexShrink:0, background:'#F3F0EA' }} />}
            <div style={{ flex:1, minWidth:0 }}>
              <div style={{ display:'flex', alignItems:'center', gap:'0.5rem', flexWrap:'wrap' }}>
                <span style={{ fontFamily:'Nunito Sans, sans-serif', fontWeight:700, fontSize:'0.88rem', color:'#1A1A1A' }}>{b.business_name}</span>
                <VerifiedBadge status={b.verification_status} size={16} />
              </div>
              <p style={{ fontFamily:'Nunito Sans, sans-serif', fontSize:'0.72rem', color:'#9B9B9B', margin:'0.1rem 0 0' }}>{CATEGORY_LABELS[b.category] || b.category}</p>
            </div>
            {(() => { const lbl = bookingLabel(b); return (
              <span style={{ fontFamily:'Nunito Sans, sans-serif', fontSize:'0.66rem', fontWeight:700, color: lbl.tone,
                background: lbl.bg, borderRadius:100, padding:'2px 9px', flexShrink:0, whiteSpace:'nowrap' }}>
                {lbl.text}
              </span>
            )})()}
          </button>
        ))}
      </div>
    </div>
  )
}
